import * as React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  Button,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import LanguageIcon from "@mui/icons-material/Language";
import CheckIcon from "@mui/icons-material/Check";
import { locales, type Locale, isLocale } from "../../i18n/locales";
import { useI18n } from "../../i18n/I18nProvider";

const LABEL: Record<Locale, string> = {
  el: "Ελληνικά",
  en: "English",
  ru: "Русский",
  sr: "Srpski",
  ro: "Română",
  bg: "Български",
  mk: "Македонски",
};

const FLAG: Record<Locale, string> = {
  el: "🇬🇷",
  en: "🇬🇧",
  ru: "🇷🇺",
  sr: "🇷🇸",
  ro: "🇷🇴",
  bg: "🇧🇬",
  mk: "🇲🇰",
};

export default function LanguageSwitcher() {
  const { locale, setLocale } = useI18n();
  const nav = useNavigate();
  const loc = useLocation();

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const switchTo = (next: Locale) => {
    const parts = loc.pathname.split("/").filter(Boolean);

    // Αν δεν έχει locale στο URL, κάνε prepend
    if (!parts[0] || !isLocale(parts[0])) {
      const url = `/${next}${loc.pathname.startsWith("/") ? "" : "/"}${loc.pathname}${loc.search}`;
      setLocale(next);
      nav(url);
      setAnchorEl(null);
      return;
    }

    parts[0] = next;
    const url = "/" + parts.join("/") + loc.search;

    setLocale(next);  // ✅ αυτό κάνει να αλλάξουν τα t() άμεσα
    nav(url);         // ✅ αυτό αλλάζει πραγματικά route
    setAnchorEl(null);
  };

  return (
    <>
      <Button
        onClick={(e) => setAnchorEl(e.currentTarget)}
        variant="text"
        sx={{ borderRadius: 999 }}
        startIcon={<LanguageIcon />}
      >
        <Stack direction="row" spacing={1} alignItems="center">
          <Typography component="span">{FLAG[locale]}</Typography>
          <Typography component="span">{LABEL[locale]}</Typography>
        </Stack>
      </Button>

      <Menu anchorEl={anchorEl} open={open} onClose={() => setAnchorEl(null)}>
        {locales.map((l) => (
          <MenuItem key={l} onClick={() => switchTo(l)}>
            <ListItemIcon sx={{ minWidth: 34 }}>
              {l === locale ? <CheckIcon fontSize="small" /> : <span style={{ width: 24 }} />}
            </ListItemIcon>
            <ListItemIcon sx={{ minWidth: 34 }}>
              <span style={{ fontSize: 18, lineHeight: 1 }}>{FLAG[l]}</span>
            </ListItemIcon>
            <ListItemText primary={LABEL[l]} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
}
